import { ACTION_TYPES } from './actionTypes.js';

export function reducer(state, action) {

  switch (action.type) {
 
    case ACTION_TYPES.updateFilterSelection:
      return {
        ...state,
        selectedModel: {
          ...state.selectedModel,
          filterClassificationId: action.classificationId,
          carouselIndex: 0,
          index: state.filters[action.classificationId].indexes[0]
        }
      }
    
    case ACTION_TYPES.setConfiguratorActiveStatus:
      return {
        ...state,
        configuratorActive: action.configuratorActive,
      }
    
    case ACTION_TYPES.setActiveModelIndex:
      return {
        ...state,
        selectedModel: {
          ...state.selectedModel,
          index: action.activeIndex,
          carouselIndex: action.carouselIndex
        }
      }

    case ACTION_TYPES.updateImageProps: 
      return {
        ...state,
        models: state.models.map((model, index) => index === state.selectedModel.index ? 
          ({
            ...model,
            displayCard : {
              ...state.models[state.selectedModel.index].displayCard,
              ccisImgConfig: action.imageProps
            }
          }) : 
          (model))
      }
    
    case ACTION_TYPES.updateConfiguratorActiveSelections:
      return {
        ...state,
        models: state.models.map((model, index) => index === state.selectedModel.index ? 
        ({
          ...model,
          configurator: {
            ...state.models[state.selectedModel.index].configurator,
            activeSelections: action.activeSelections
          }
        }) : 
        (model))
      }

    default:
      return state;
  }
};
